import {
  Int32IdAndLabel,
  GuidIdCodeAndLabel,
  StationOrLocationItem,
  CodeAndLabel,
  GuidIdAndLabel, BrandAndMarketListItem, SearchRuleOrderValue,
} from '../../../integrated-client/models';
import {DEFAULT_PAGE_SIZE} from "../../../utils/Constants";

export interface IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  distributionChannel?: Int32IdAndLabel
  agency?: GuidIdCodeAndLabel
  agencyOnly?: boolean
  fareType?: CodeAndLabel | null;
  origin?: StationOrLocationItem
  supplier?: GuidIdAndLabel | null;
  carrier?: GuidIdCodeAndLabel | null;  
  description?: string
  destination?: StationOrLocationItem | null;
  relevance?: number | null;
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean;
  orderValue?: SearchRuleOrderValue;
  offset: number
  limit: number
}

export class FiltersData implements IFiltersData {
  brandAndMarket?: BrandAndMarketListItem
  distributionChannel?: Int32IdAndLabel
  agency?: GuidIdCodeAndLabel
  agencyOnly?: boolean
  origin?: StationOrLocationItem
  supplier?: GuidIdAndLabel | null;
  carrier?: GuidIdCodeAndLabel | null;
  description?: string
  destination?: StationOrLocationItem | null;
  relevance?: number
  showDeleted?: boolean
  showDisabled?: boolean
  orderByDescending?: boolean
  orderValue?: SearchRuleOrderValue
  offset: number
  limit: number
  basis?: any;

  constructor() {
    this.offset = 0;
    this.limit = DEFAULT_PAGE_SIZE;
  }

}
